import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SmartintegService } from '../../../services/smartinteg.service';
import { ProvedorConexao } from '../../../types/smartinteg';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-seletor-conexao',
  templateUrl: './seletor-conexao.component.html',
  styleUrl: './seletor-conexao.component.css'
})
export class SeletorConexaoComponent implements OnInit {

  @Input() provedorId: string = '';
  @Input() disabled: boolean = false;
  @Input() placeholder: string = 'Selecione uma conexão';
  @Input() label: string = 'Conexão';
  @Input() conexaoSelecionadaId?: string;

  @Output() conexaoSelecionada = new EventEmitter<ProvedorConexao>();

  conexoes: ProvedorConexao[] = [];
  conexaoAtual?: ProvedorConexao;
  loading: boolean = false;

  constructor(
    private smartintegService: SmartintegService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    if (this.provedorId) {
      this.carregarConexoes();
    }
  }

  ngOnChanges(): void {
    if (this.provedorId) {
      this.carregarConexoes();
    }
  }

  carregarConexoes(): void {
    this.loading = true;
    this.smartintegService.listarConexoesPorProvedor(this.provedorId).subscribe({
      next: (conexoes) => {
        this.conexoes = conexoes;

        // Se há uma conexão pré-selecionada, encontrar e emitir
        if (this.conexaoSelecionadaId) {
          const conexaoPreSelecionada = conexoes.find(c => c.id === this.conexaoSelecionadaId);
          if (conexaoPreSelecionada) {
            this.conexaoAtual = conexaoPreSelecionada;
            this.conexaoSelecionada.emit(conexaoPreSelecionada);
          }
        }

        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar conexões: ' + error.error?.message);
        this.loading = false;
      }
    });
  }

  onConexaoChange(event: any): void {
    const conexao = this.conexoes.find(c => c.id === event.value);
    if (conexao) {
      this.conexaoSelecionada.emit(conexao);
    }
  }
}
